import './application.css'
import StaticForms from 'controllers/static_forms'

StaticForms()
